module.exports = __webpack_public_path__ + "static/img/orange.d988156f.png";